
import React from "react";
 import "./Contact.css";
 import { VscGithub } from "react-icons/vsc";
 import { CgMail } from "react-icons/cg";
import { BsFillTelephoneFill } from "react-icons/bs";
import { ThemeContext } from "../../Context/theme";
import GitHubIcon from "@material-ui/icons/GitHub";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import EmailIcon from "@material-ui/icons/Email";
import PhoneIcon from "@material-ui/icons/Phone";
import PublicIcon from "@material-ui/icons/Public";

 //import { Twitter } from "@material-ui/icons";

import { FaLinkedin } from "react-icons/fa";


const Contact = () => {
  return (
<div id="contact">
<h2 className="section__title" data-aos="fade-right">
      Get in <span className="different" id="to">Touch</span></h2>

<div className="mainn">
    
    <div className="main-1">
      <div className="img-hand">
        <img src="https://th.bing.com/th/id/OIP.3OI0KC9E8WXIDZVqo-ajgQHaE2?w=239&h=180&c=7&r=0&o=5&pid=1.7" />
      </div>
      <div className="text-line2">
        <p id="name">Ruchi Priya Kumari</p>
        <p className="text-line1">Full stack developer</p>
        <p className="text-line1">
          I am available for Full Stack development. Connect with me via email
          and phone number.
        </p>
        <div className="phone">
          <div className="text-line3">
            <p>Phone: </p>
            <p  id="contact-phone">+91-8076166383</p>
          </div>
          <div className="text-line3">
            <p>Email: </p>
            <p id="contact-email">ruchipriya1009@gmail.com</p>
          </div>
          <div className="git">
          

          </div>
          
        </div>
      </div>
      
   <div className="about__contact center">
          <a  id="contact-github"
            href="https://github.com/ruchipriya1009"
            aria-label="github"
            target="_blank"
            rel="noreferrer"
            className="link link--icon"
          >
            <GitHubIcon />
          </a>
          <a id="contact-email"
            href="mailto:ruchipriya1009@gmail.com"
            target="_blank"
            rel="noreferrer"
            aria-label="github"
            className="link link--icon"
          >
            <EmailIcon />
          </a>
          <a id="contact-phone"
            href="tel:+918076166383"
            target="_blank"
            rel="noreferrer"
            aria-label="github"
            className="link link--icon"
          >
            <PhoneIcon />
          </a>
          
          
          
          <a
            href="https://goo.gl/maps/qPxRMWbWZqeRMfyXA"
            aria-label="github"
            className="link link--icon"
            target="_blank"
            rel="noreferrer"
          >
            <PublicIcon />
          </a> 
        </div>
      
    </div>

    {/* Third Part */}
    

    {/* second part  */}

    <div className="main-2">

      <form action="https://getform.io/f/fceb0098-a132-4557-9191-f23e12e377dd" method="POST">

        <div className="form-1">
          <div className="form-2">
            <label>NAME</label>
            <br />
            <input type="text" name="name" required />
          </div>
          <div className="form-2 ">
            <label>PHONE NUMBER</label>
            <br />
            <input type="number" name="number"required />
          </div>
        </div>

        <div className="form-2 form-3">
          <label>EMAIL</label>
          <br />
          <input type="text" name="email" required />
        </div>
        <div className="form-2 form-3">
          <label>SUBJECT</label>
          <br />
          <input type="text" name="subject" required />
        </div>
        <div className="form-2 form-3">
          <label>YOUR MESSAGE</label>
          <br />
          <textarea type="text"   name="message" required />
        </div>

        <input className="btn-send1" type="submit" value="SEND MESSAGE ➔" />
      </form>
    </div>
  </div>


</div>

   
  );
};

export default Contact;
